<template>
  <modal-form v-model="show" :submit="submit">
    <template v-slot:title>
      Enviar por E-mail para
    </template>
    <template v-slot:body>
      <v-col cols="12">
        <input-email required label="Email" v-model="model.Email" readonly disabled></input-email>
      </v-col>
    </template>
  </modal-form>

</template>
<script>
export default {
  data () {
    return {
      show: false,
      model: {}
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      if (sender) {
        th.model = sender
      }
      th.$api.Multiplo.SelectPessoa({ filter: { tipoRegistro: 1, DocumentoCliente: sender.Cliente.DocumentoFederal } }).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.$set(th.model, 'Email', JSON.parse(response.JSON).PessoaDadosContato.Email)
        }
      })
    },
    submit () {
      const th = this
      const obj = {
        dto: {
          CodigoProposta: th.model.Codigo,
          Email: th.model.Email
        }
      }
      th.$api.Multiplo.EnviarPorEmailPropostaParcela(obj).then(function (response) {
        if (th.$api.UI.PostAction(response)) {
          th.show = false
          th.$emit('close', !response.error)
        }
      })
    }
  }
}
</script>
